import { render, staticRenderFns } from "./LivestreamTermsOfService.vue?vue&type=template&id=36b5c14e&scoped=true"
import script from "./LivestreamTermsOfService.vue?vue&type=script&lang=js"
export * from "./LivestreamTermsOfService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b5c14e",
  null
  
)

export default component.exports